const apiVersion = 'v1';

export default {
    //Hr 
    AUTH_API_ROOT_HR: `/api/auth/human-resource`,
    API_ROOT_HR: `/api/${apiVersion}/human-resource`,

    //Placement officer
    AUTH_API_ROOT_PO: `/api/auth/placement-officer`,
    API_ROOT_PO: `/api/${apiVersion}/placement-officer`,

    //Student
    AUTH_API_ROOT_STUDENT: `/api/auth/student`,
    API_ROOT_STUDENT: `/api/${apiVersion}/student`,

    

    API_LOCATION: `/api/${apiVersion}/utility`,

    //chat api
    CHAT_API: `/api/${apiVersion}/chat`,

    //notification
    NOTIFICATION_API: `/api/${apiVersion}/notification`
};
